import React from 'react';

import {
  Grid,
} from '@mui/material';

import TransactionTypeConfiguration from './TransactionTypeConfiguration';

const TransactionNameMatching = () => (
  <Grid size={12}>
    <Grid container spacing={1}>
      <TransactionTypeConfiguration />
    </Grid>
  </Grid>

);

export default TransactionNameMatching;
